import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../App.css';

const Leagues = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const options = {
                method: 'GET',
                url: 'https://api-football-v1.p.rapidapi.com/v3/leagues',
                headers: {
                    'X-RapidAPI-Key': '3a1f5c1448msh76651723dbbc972p1224a1jsn4f654d29b46a',
                    'X-RapidAPI-Host': 'api-football-v1.p.rapidapi.com'
                }
            };

            try {
                const response = await axios.request(options);
                setData(response.data.response);
              
            } catch (error) {
                console.error(error);
            }
        };

        fetchData();
    }, []);

    return (
        <div className='leagues-container'>
            {data.map(league => (
                <div key={league.league.id} className='league'>
                    <img className='leaguelogo' src={league.league.logo} alt={`${league.league.name} Logo`} />
                    <p className='leaguename'>{league.league.name}</p>

                </div>
            ))}
        </div>
    );
};

export default Leagues;
